import { api, system } from "@/axios"
import { format } from 'd3-format'
import { ref } from 'vue'

export const useHttpService = () => {
  const loading = ref(false)
  const error = ref(null)

  const handleSuccess = (response, msg) => {
    console.log(msg)

    return response.data
  }

  const handleError = err => {
    error.value = err.response ? err.response.data : 'Network error'
    console.error('API Error:', error.value)

    return Promise.reject(error.value)
  }

  const httpDelete = async (endPoint, id, msg = 'Item Deleted', useSystemApi = false) => {
    loading.value = true
    try {
      const url = id ? `/${endPoint}/${id}` : `/${endPoint}`
      const instance = useSystemApi ? system : api

      console.log("DELETE request URL:", url)

      const response = await instance.delete(url)

      return handleSuccess(response, msg)
    } catch (err) {
      return handleError(err)
    } finally {
      loading.value = false
    }
  }


  const httpPostPut = async (endPoint, operation, payload, id, useSystemApi = false) => {
    const method = operation === 'add' ? 'post' : 'put'
    const url = operation === 'add' ? `/${endPoint}` : `/${endPoint}/${id}`
    const msg = operation === 'add' ? 'Item Added' : 'Item Updated'
    const instance = useSystemApi ? system : api

    loading.value = true
    try {
      const response = await instance({ method, url, data: payload })

      return handleSuccess(response, msg)
    } catch (err) {
      return handleError(err)
    } finally {
      loading.value = false
    }
  }

  const httpGet = async (endPoint, params = "", sort = "", useSystemApi = false) => {
    const addParam = params ? `?${params}${sort}` : ''
    const instance = useSystemApi ? system : api

    loading.value = true
    try {
      const response = await instance.get(`/${endPoint}${addParam}`, { useCredentails: true })

      return response.data
    } catch (err) {
      return handleError(err)
    } finally {
      loading.value = false
    }
  }

  const httpPost = async (endPoint, payload, params = "", sort = "", useSystemApi = false) => {
    const url = `/${endPoint}?${params}${sort}`
    const instance = useSystemApi ? system : api

    loading.value = true
    try {
      const response = await instance.post(url, payload)

      return response.data
    } catch (err) {
      return handleError(err)
    } finally {
      loading.value = false
    }
  }


  // ======================re usable function ===================================

  // Reusable formatting functions
  const numberWithCommas = x => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  }

  const formatToMillion = x => {
    return format('.4s')(x)
  }


  const calculatePercentage = (male, female, total) => {


    if (total === 0) {
      return {
        malePercentage: 0,
        femalePercentage: 0,
      }
    }

    const malePercentage = (male / total) * 100
    const femalePercentage = (female / total) * 100

    return {
      malePercentage: malePercentage.toFixed(2),  // Rounds to 2 decimal places
      femalePercentage: femalePercentage.toFixed(2),
    }
  }

  const getVisitorCount = async () => {
    try {
      const response = await api.get('/visitor-count')
      return response.data
    } catch (err) {
      console.error('Failed to fetch visitor count:', err)
      return { count: 1234 } // Return mock data on error for demo purposes
    }
  }

  return {
    loading,
    error,
    httpDelete,
    httpPostPut,
    httpGet,
    httpPost,
    numberWithCommas,
    formatToMillion,
    calculatePercentage,
    getVisitorCount,
  }
}





{/* <template>
  <div>
    <button @click="deleteItem(1)">Delete Item</button>
    <div v-if="loading">Loading...</div>
    <div v-if="error">{{ error }}</div>
  </div>
</template>

<script>
import { useHttpService } from "@/services/httpService"; // Adjust the path as necessary
import { ref } from 'vue';

export default {
  setup() {
    const { loading, error, httpDelete, httpPostPut, httpGet, httpPost } = useHttpService();

    const deleteItem = async (id) => {
      try {
        const response = await httpDelete('items', id, 'Item deleted successfully');
        console.log(response);
      } catch (err) {
        console.error(err);
      }
    };

    return {
      deleteItem,
      loading,
      error
    };
  }
};
</script> */}
